import { z } from 'zod'

export const createSchema = z.object({
  transaction_identifier: z.string({ message: 'Campo obrigatório' }),
  reason: z.string().min(8, { message: 'Tamanho mínimo: 8 caracteres' }),
})

export type RefundValidationSchema = z.infer<typeof createSchema>
